import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme } from '@mui/material/styles';
import { PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_TEXT, PROMETHEAN_TEXT_HEADER } from '../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_SUBTITLE_04 } from '../styles/typography/typography';
export var stepperTheme = createTheme({
  components: {
    MuiStepper: {
      styleOverrides: {
        root: {
          '&.EmbersStepper-root': {
            marginLeft: -8,
            marginRight: -8,
            paddingTop: 16
          },
          '.MuiStep-root': {
            flexBasis: '99px',
            maxWidth: '234px',
            flexShrink: 0,
            '&.active-step + .MuiStep-root': {
              '.MuiStepConnector-root': {
                left: 'calc(-100% + 68px)'
              }
            },
            '.MuiStepConnector-root': {
              borderColor: PROMETHEAN_TEXT_HEADER,
              left: 'calc(-100% + 50px)',
              right: 'calc(100% - 6px)',
              '.MuiStepConnector-line': {
                borderColor: PROMETHEAN_TEXT
              }
            },
            i: {
              fontSize: '40px',
              marginTop: '-8px',
              '&.completed,&.active': {
                color: PROMETHEAN_PURPLE_GRAPE
              },
              '&.active': {
                fontSize: '60px',
                marginTop: '-18px'
              }
            },
            '.MuiStepLabel-root': {
              alignItems: 'flex-start',
              '.MuiStepLabel-label': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_04), {}, {
                color: PROMETHEAN_TEXT,
                textAlign: 'left',
                marginTop: '10px',
                paddingLeft: '6px',
                '&.Mui-active': {
                  marginTop: 0,
                  paddingLeft: '8px'
                }
              })
            }
          }
        }
      }
    }
  }
});